<template>
    <div :class="[$style['mds-button-group'], classObject, sizeClass]" role="group" :data-mds-version="version">
        <mds-button-group-item
            v-for="(item, index) in content"
            :key="index"
            v-bind="item"
            v-on:mds-button-group-item-active="$emit('mds-button-group-item-active', $event)"
        >
        </mds-button-group-item>
    </div>
</template>

<script>
    import MdsButtonGroupProps from './button-group_props.js';
    import MdsButtonGroupItem from './button-group-item.vue';

    export default {
        name: 'MdsButtonGroup',
        components: {
            MdsButtonGroupItem,
        },
        props: MdsButtonGroupProps,
        provide() {
            // Properties that are available for injection into components descendants https://vuejs.org/v2/api/#provide-inject
            const parentVariation = {};
            Object.defineProperty(parentVariation, 'size', {
                enumerable: true,
                get: () => this.size,
            });
            return { parentVariation };
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-button-group--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-button-group--full-width']] = this.fullWidth === true;
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './button-group.scss';
</style>
